import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-secondary-dark h-[6px] overflow-hidden rounded-[100px]',
    line: 'transition-width before:bg-icon-star relative duration-500 before:block before:h-[6px]'
  }
});
